import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.companyEdit || initialState;

export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectCountries = createSelector(
  [selectDomain],
  (state) => state.countries
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectCities = createSelector(
  [selectDomain],
  (state) => state.cities
);

export const selectCompanyDetails = createSelector([selectDomain], (state) => {
  const companyDetails = state.companyDetails;
  if (companyDetails) {
    return {
      ...companyDetails,
      /*pickupAddress: companyDetails?.pickupAddress.map((add) => ({
        ...add,
        state: add?.state?._id,
        country: add?.country?._id,
        city: add?.city?._id,
      })),
      billingAddress: companyDetails?.billingAddress.map((add) => ({
        ...add,
        state: add?.state?._id,
        country: add?.country?._id,
        city: add?.city?._id,
      }),*/
      registeredAddress: {
        ...companyDetails.registeredAddress,
        state: companyDetails?.registeredAddress?.state?._id,
        country: companyDetails?.registeredAddress?.country?._id,
        city: companyDetails?.registeredAddress?.city?._id,
      },
      paymentMethodsAvailable: companyDetails?.paymentMethodsAvailable?.map(
        (opt) => opt._id
      ),
      businessType: companyDetails.businessType?._id,
    };
  }
  return {};
});

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
